import { memo, useState } from "react";
import { Icon } from "@mdi/react";
import { mdiWeb } from "@mdi/js";
import cx from "classnames";
import { Dropdown } from "@base/ui/Dropdown";
import { useTranslation } from "react-i18next";

export const LANGUAGE_MAP = {
  ko: "Korean",
  en: "English",
};

export const LANGUAGE_SHORT_CODE_MAP = {
  ko: "KOR",
  en: "ENG",
};

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [isActive, setIsActive] = useState(false);

  const handleSelectLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsActive(false);
  };

  const currentLanguage = i18n.language;

  return (
    <Dropdown
      open={isActive}
      onOpenChange={(details) => {
        setIsActive(details.open);
      }}
    >
      <Dropdown.Trigger asChild>
        <span className={cx("inline-flex gap-2 items-center px-4 transition-opacity cursor-pointer hover:opacity-80")}>
          <Icon path={mdiWeb} size="1rem" className="shrink-0" />
          {currentLanguage
            ? LANGUAGE_SHORT_CODE_MAP[currentLanguage as keyof typeof LANGUAGE_SHORT_CODE_MAP]
            : "Language"}
        </span>
      </Dropdown.Trigger>
      <Dropdown.Content className="z-languageDropdown p-2 min-w-[120px]">
        {Object.keys(LANGUAGE_MAP).map((key) => (
          <Dropdown.Item
            value={key}
            key={key}
            onClick={() => handleSelectLanguage(key)}
            className={cx(
              "px-3 py-2 cursor-pointer rounded-4 transition-colors",
              "hover:bg-primary-10",
              currentLanguage === key ? "font-semibold" : "",
            )}
          >
            {LANGUAGE_MAP[key as keyof typeof LANGUAGE_MAP]}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
};

export default memo(LanguageDropdown);
